import { render } from "./SelectRooms.vue?vue&type=template&id=6efa6472&ts=true"
import script from "./SelectRooms.vue?vue&type=script&lang=ts"
export * from "./SelectRooms.vue?vue&type=script&lang=ts"

import "./SelectRooms.vue?vue&type=style&index=0&id=6efa6472&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__